var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 34.5C8.61104 34.5 1 26.889 1 17.5C1 8.11104 8.61104 0.5 18 0.5C27.389 0.5 35 8.11104 35 17.5C35 26.889 27.389 34.5 18 34.5ZM24.9636 9.60704H22.2266L18.182 16.8391H18.1147L14.0702 9.60704H11.3218L16.2554 17.9774H13.0679V19.2503H16.9092V21.0417H13.0679V22.3145H16.9092V25.5474H19.365V22.3145H23.2062V21.0417H19.365V19.2496H23.2062V17.9767H20.0187L24.9636 9.60704Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.3dd951b78984c0b89c62c6153b92051a.svg";
export { ForwardRef as ReactComponent };